import { createTheme } from '@mui/material';
import { ColorPalette } from '../constants';

export const customPalette = createTheme({
  palette: {
    primary: {
      main: ColorPalette.TIFFANY_BLUE,
      light: ColorPalette.COLUMBIA_BLUE,
      dark: ColorPalette.MIDDLE_BLUE,
      contrastText: ColorPalette.RAISIN_BLACK,
    },
    secondary: {
      main: ColorPalette.CHINESE_BLACK,
      light: ColorPalette.CONFIRM_BLUE,
      dark: ColorPalette.LIGHT_GRAY,
      contrastText: ColorPalette.DARK_GRAY,
    },
    info: {
      main: ColorPalette.CONFIRM_BLUE,
    },
    success: {
      main: ColorPalette.GREEN,
    },
    error: {
      main: ColorPalette.WARNING_RED,
    },
  },
});
